package com.macrofocus.eflux

import web.cssom.ident

object Area {
    val Header = ident("header")
    val Sidebar = ident("sidebar")
    val Fabbar = ident("fabbar")
    val Content = ident("content")
}